<template>
  <div
    v-if="display && showComponent"
    :title="qaAble ? showIfHasPermission?.toString() : null"
    :key="componentRefresh"
  >
    <div :style="{'display':'flex','flex-direction':'column','height':height, 'width':width}">
      <input
        :id="`inputFieldFile${_uid}`"
        type="file"
        :disabled="disabled||!enableComponent"
        multiple
        style="display: none;"
      >
      <div 
        :id="`inputFileDrag${_uid}`" 
        class="file-drag-container"
      >
        <small>Upload a new file from your system.</small>
        <small>Drop file(s) here.</small>
        <small>or</small>
        <small>
          <a href="" @click.prevent="click"> <i class="fas fa-cloud-upload-alt"></i> Choose files </a>
        </small>
        <small v-if="fileArrayList.length > 0"> Added Files {{ fileArrayList.length }}</small>
      </div>
    </div>
  </div>
</template>
<script>
import checkPermissions from '../../mixins/checkPermissions';
import fileTypeIs from '../../mixins/fileTypeIs';
export default {
  name: 'dropzone',
  mixins: [checkPermissions, fileTypeIs],
  props: {
    multiple:{
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    display: {
      type: Boolean,
      default: true
    },
    maxSizeFile: {
      type: Number, //MB
      default: null
    },
    height:{
      type: String,
      default: "100%"
    },
    width:{
      type: String,
      default: "100%"
    }
  },
  computed: {
    qaAble(){
      return app.store.state.ks_app.global_data.qaAble;
    },
    fileArrayList(){
      return Array.from(this.files);
    }
  },
  methods: {
    init() {
      this.fileSelect = document.getElementById(`inputFieldFile${this._uid}`);
      this.fileSelect.addEventListener("change", this.fileSelectHandler, false);

      this.filedrag = document.getElementById(`inputFileDrag${this._uid}`);
      this.filedrag.addEventListener("dragover", this.fileDragHover, false);
      this.filedrag.addEventListener("dragleave", this.fileDragHover, false);
      this.filedrag.addEventListener("drop", this.fileSelectHandler, false);
    },

    click() {
      this.fileSelect.click();
      this.$emit('onClick', this);
    },

    fileDragHover(e) {
      e.stopPropagation();
      e.preventDefault();
      if (e.type == "dragover") {
        e.target.classList.add("file-drag-container-dragover");
      } else {
        e.target.classList.remove("file-drag-container-dragover");
      }
    },

    fileSelectHandler(e) {
      this.fileDragHover(e);
      let files;
      if(e.target.files && e.target.files.length > 0){
        files = e.target.files;
      }else if(e.dataTransfer.files && e.dataTransfer.files.length > 0){
        let auxFileList = new DataTransfer();
        Array.from(e.dataTransfer.files).forEach((file, index) => {
          const newName = Date.now() + index + '.' +file.name.split('.').pop();
          const renamedFile = new File([file], newName, {
            type: file.type,
            lastModified: file.lastModified,
          });
          auxFileList.items.add(renamedFile);
        }) 
        files = auxFileList.files;
      }else{
        return;
      }
      this.mergeFiles(files);
      this.fileSelect.value = '';
    },

    removeFile(index) {
      const dt = new DataTransfer();
      for(let i = 0; i < this.files.length; i++){
        if(i!==index){ dt.items.add(this.files[i])}
      }
      this.files = dt.files;
      this.$emit('onChange', this);
    },
    
    mergeFiles(files){
      let aux = Array.from(files);
      if (this.maxSizeFile != null && this.maxSizeFile > 0) {
        aux = aux.filter(file => (this.maxSizeFile * 1048576) > file.size);
      }
      let concatLists = [...Array.from(this.files), ...aux];
      const uniqueFiles = Array.from(new Set(concatLists.map(file => file.name))).map(name => concatLists.find(file => file.name === name));
      const dataTransfer = new DataTransfer();
      uniqueFiles.forEach(file => dataTransfer.items.add(file));
      this.files = dataTransfer.files;
      this.$emit('onChange', this);
    },

    reset() {
      let dt = new DataTransfer();
      this.files = dt.files;
      this.fileSelect.value = '';
      this.$emit('onChange', this);
    },

    set(files){
      this.files = files;
    },

    get(){
      return this.files;
    }
  },
  mounted() {
    this.init();
  },
  data() {
    let dt = new DataTransfer();
    return {
      fileSelect: null,
      filedrag: null,
      files: dt.files
    }
  }
}
</script>

<style>
.file-drag-container {
  min-height: 75px;
  font-weight: bold;
  font-size: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1em 0;
  margin: 1em 0;
  color: #555;
  border: 2px dashed #555;
  border-radius: 7px;
}

.file-drag-container:hover {
  background: #dadada;
  cursor: grabbing;
}

.file-drag-container-dragover {
  color: #212121;
  border: 2px dashed #0064cc;
  background: #d2d2d2;
}
</style>
